export let ShareData =  {
    currentService: null,
    allService: null,
    currentMessage: null
}
